// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: block;
}

ion-grid {
  padding: 0.5rem 1.25rem 0.6rem;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  margin: 0;
  border-radius: 0.25rem;
  gap: 3rem;
  height: 100%;
}
ion-grid .games-section:only-child .list {
  flex-wrap: wrap;
}
ion-grid ion-item {
  flex-shrink: 0;
  --min-height: unset;
}
ion-grid ion-item::part(native) {
  flex-direction: column;
  align-items: flex-start;
}
ion-grid .title {
  font-size: 1.27rem;
  font-weight: 500;
  line-height: 1.49rem;
  text-align: left;
  color: #333333;
  margin-bottom: 0.5rem;
}
ion-grid .list {
  gap: 0.8125rem;
  display: flex;
}
ion-grid .list .game {
  border: 1.45px solid #000000;
  width: 3.54rem;
  height: 3.54rem;
  border-radius: 0.5rem;
  background-size: contain;
  background-position: center;
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  ion-grid {
    padding: 0.3125rem 0.875rem 0.5rem;
    gap: 1.5rem;
    overflow: auto;
  }
  ion-grid .title {
    font-size: 0.875rem;
    line-height: 1.03rem;
  }
  ion-grid .list {
    gap: 0.56rem;
  }
  ion-grid .list .game {
    width: 2.44rem;
    height: 2.44rem;
  }
}
@media screen and (max-width: 410px) {
  ion-grid {
    padding: 0.3125rem 0.375rem 0.5rem;
    gap: 0.8rem;
  }
  ion-grid .list {
    gap: 0.2rem;
  }
}
@media screen and (max-width: 350px) {
  ion-grid {
    padding: 0.5rem 0.875rem 0.5rem;
    gap: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
  ion-grid .list {
    gap: 0.56rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/games-section/games-section.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAEJ;AACQ;EACI,eAAA;AACZ;AAGI;EACI,cAAA;EACA,mBAAA;AADR;AAGQ;EACI,sBAAA;EACA,uBAAA;AADZ;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAKI;EACI,cAAA;EACA,aAAA;AAHR;AAKQ;EACI,4BAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;EACA,eAAA;AAHZ;;AAQA;EACI;IACI,kCAAA;IACA,WAAA;IACA,cAAA;EALN;EAOM;IACI,mBAAA;IACA,oBAAA;EALV;EAQM;IACI,YAAA;EANV;EAQU;IACI,cAAA;IACA,eAAA;EANd;AACF;AAWA;EACI;IACI,kCAAA;IACA,WAAA;EATN;EAWM;IACI,WAAA;EATV;AACF;AAaA;EACI;IACI,+BAAA;IACA,SAAA;IACA,sBAAA;IACA,uBAAA;EAXN;EAaM;IACI,YAAA;EAXV;AACF","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\nion-grid {\r\n    padding: 0.5rem 1.25rem 0.6rem;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    margin: 0;\r\n    border-radius: 0.25rem;\r\n    gap: 3rem;\r\n    height: 100%;\r\n\r\n    .games-section:only-child {\r\n        .list{\r\n            flex-wrap: wrap;\r\n        }\r\n    }\r\n\r\n    ion-item {\r\n        flex-shrink: 0;\r\n        --min-height: unset;\r\n\r\n        &::part(native) {\r\n            flex-direction: column;\r\n            align-items: flex-start;\r\n        }\r\n    }\r\n\r\n    .title {\r\n        font-size: 1.27rem;\r\n        font-weight: 500;\r\n        line-height: 1.49rem;\r\n        text-align: left;\r\n        color: #333333;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n    .list {\r\n        gap: 0.8125rem;\r\n        display: flex;\r\n\r\n        .game {\r\n            border: 1.45px solid #000000;\r\n            width: 3.54rem;\r\n            height: 3.54rem;\r\n            border-radius: 0.5rem;\r\n            background-size: contain;\r\n            background-position: center;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    ion-grid {\r\n        padding: 0.3125rem 0.875rem 0.5rem;\r\n        gap: 1.5rem;\r\n        overflow: auto;\r\n\r\n        .title {\r\n            font-size: 0.875rem;\r\n            line-height: 1.03rem;\r\n        }\r\n\r\n        .list {\r\n            gap: 0.56rem;\r\n\r\n            .game {\r\n                width: 2.44rem;\r\n                height: 2.44rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 410px) {\r\n    ion-grid {\r\n        padding: 0.3125rem 0.375rem 0.5rem;\r\n        gap: 0.8rem;\r\n\r\n        .list {\r\n            gap: 0.2rem;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 350px) {\r\n    ion-grid {\r\n        padding: 0.5rem 0.875rem 0.5rem;\r\n        gap: 1rem;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n\r\n        .list {\r\n            gap: 0.56rem;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
